import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { getSceneIcon } from '../../Common/Common';

export default class Scene_Settings extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();

		this.scenes = this.props.param.scenes;
		if (this.props.receiver.active_controller.user_class != 'Admin') { //If user class is not Admin
			let temp_scenes = {};
			let accessible_points = this.props.receiver.active_controller.auth.points;
			for (let key in this.scenes) {
				let scene_owner = this.scenes[key].owner; //Retrieve the owner of the scene
				if (scene_owner != 'Admin') { //Only can access scene settings created by ownself
					for (let mp in this.scenes[key].action) {
						if (accessible_points.hasOwnProperty(mp)) {
							temp_scenes[key] = this.scenes[key];
						}
					}
				}
			}
			this.scenes = temp_scenes;
		}


		this.state = {

		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler(this.props.param.from);
	}

	handleEditScene = (scene_id) => {
		this.props.content_handler('Add_Edit_Scene', { scene_id: scene_id, scenes: this.props.param.scenes, from: this.props.param.from });
	}

	handleAddScene = () => {
		this.props.content_handler('Add_Edit_Scene', { scene_id: null, scenes: this.props.param.scenes, from: this.props.param.from });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let scene_button_style = {
			cursor: 'pointer',
			width: this.props.width - 80,
			padding: '10px 20px',
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			textAlign: 'left',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('scene')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddScene}
					/>
					<div style={{ height: this.props.height - 140, paddingBottom: 60, overflow: 'auto' }}>
						{/* Only display scenes which user has access to at least 1 mp */}
						{Object.keys(this.scenes).map((scene_id) => {
							let scene = this.scenes[scene_id];
							let icon = getSceneIcon(scene.icon)
							return (
								<div style={scene_button_style} onClick={() => this.handleEditScene(scene_id)}>
									<div style={{ display: 'inline-block' }}>
										<img src={icon} style={{ width: 30 }} />
									</div>
									<div style={{ display: 'inline-block', width: this.props.width - 120, marginLeft: 10, verticalAlign: 'top', paddingTop: 5 }}>
										<span >{scene.name}</span>
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}